function addBannerCollection() {
    let totalList = document.querySelectorAll('.boost-sd-right .boost-sd__product-list .boost-sd__product-item').length;

    function getRandomNumber(min, max) {
        let randomNumber = Math.floor(Math.random() * ((max / 2) - min + 1)) + min;
        return randomNumber * 2;
    }

    let randomNumber;
    if (totalList > 7) {
        randomNumber = getRandomNumber(1, 6);
    } else {
        if(totalList = 1) {
            randomNumber = 1;
        } else {
            randomNumber = getRandomNumber(1, totalList);
        }
    }

    let bannerTotal = document.querySelectorAll('.grid-collection-banner').length;

    if (bannerTotal === 0) {
        setTimeout(function() {
            let productCards = document.querySelectorAll('.boost-sd-right .boost-sd__product-list .product-card');
            let firstEl = productCards[randomNumber];

            if (!firstEl) {
                firstEl = productCards[randomNumber];
            }

            if (firstEl) {
                let bannerDiv = document.createElement('div');
                bannerDiv.className = 'product-card grid-collection-banner';
                bannerDiv.innerHTML = '<img class="desktop" src="https://cdn.shopify.com/s/files/1/0714/3397/8157/files/haut-collection-card-text.jpg" alt="Lo que dicen nuestros expertos"><img class="mobile" src="https://cdn.shopify.com/s/files/1/0714/3397/8157/files/haut-collection-card-mob.jpg" alt="Lo que dicen nuestros expertos">';
                firstEl.parentNode.insertBefore(bannerDiv, firstEl);
            }
        }, 600);
    }
}

// Se ejecuta al cargar el DOM
document.addEventListener('DOMContentLoaded', function() {
    setTimeout(addBannerCollection, 600);
});

// Se ejecuta una vez el sitio está cargado
window.addEventListener('load', function() {
    setTimeout(addBannerCollection, 600);
});


// Agregar el listener para detectar clics en .boost-sd__pagination-button
document.addEventListener('click', (event) => {
    console.log(event.target);

    if (event.target.classList.contains('boost-sd__pagination-button') 
        || event.target.classList.contains('boost-sd__pagination-number')
        || event.target.classList.contains('boost-sd__filter-option-item')
        || event.target.classList.contains('boost-sd__filter-option-item-label')
        || event.target.classList.contains('boost-sd__button')
        || event.target.classList.contains('boost-sd__button--clear')
        || event.target.classList.contains('boost-sd__refine-by-vertical-refine-by-clear')
        || event.target.classList.contains('boost-sd__sorting-option')
        || event.target.classList.contains('boost-sd__sorting-option--active')) {
        setTimeout(addBannerCollection, 1000);
    }
});